<template>
  <hm-content>
    <div class="auth-container">
      <div class="text-center">

        <el-button type="text" @click="toAuth" v-if="!authorized">您还未进行微信公众号授权，点击马上授权</el-button>
        <el-button type="text" @click="toAuth" v-if="authorized">您的微信公众号有授权需要更新，点击更新授权</el-button>
      </div>
      <div class="text-center">
        <el-button type="text" @click="toAuth('mp')" v-if="!authorizedMp">您还未进行微信小程序授权，点击马上授权</el-button>
        <el-button type="text" @click="toAuth('mp')" v-if="authorizedMp">您微信小程序有授权需要更新，点击更新授权</el-button>
      </div>
      <div>
        <el-form label-width="120px" v-if="false">
          <!-- <el-form-item label="公众微信号">
            <span class="mr10">{{ wechatInfo.account }}</span>
            <el-button type="text" @click="unbind">解除绑定</el-button>
          </el-form-item> -->
          <el-form-item label="公众号昵称">
            <span class="mr10">{{ oaInfo.nickName }}</span>
          </el-form-item>
          <el-form-item label="主体信息">
            <span class="mr10">{{ oaInfo.principalName }}</span>
          </el-form-item>
          <el-form-item label="公众号类型">
            <span class="mr10">{{ oaInfo.serviceTypeInfo }}</span>
          </el-form-item>
          <el-form-item label="开放平台授权ID">
            <div>
              <span class="mr10">{{ oaInfo.authorizerAppid }}</span>
              <!-- <el-button type="text" @click="unbind">解除绑定</el-button> -->
            </div>
            <div class="form-item-tip">
              公众号和小程序在同一个开放平台帐号下可通过微信授权实现买家唯一身份识别
            </div>
          </el-form-item>
          <el-form-item label="授权状态">
            <div>
              <span class="mr10">已授权</span>
            </div>
            <div class="form-item-tip">
              你的店铺已获得该公众号的所有接口权限，可以正常对接微信如果使用中发现接口有异常
            </div>
          </el-form-item>
        </el-form>
        <div v-if="false">
          <hr />
          <el-form label-width="120px">
            <!-- <el-form-item label="公众微信号">
            <span class="mr10">{{ wechatInfo.account }}</span>
            <el-button type="text" @click="unbind">解除绑定</el-button>
          </el-form-item> -->
            <el-form-item label="小程序昵称">
              <span class="mr10">{{ mpInfo.nickName }}</span>
            </el-form-item>
            <el-form-item label="主体信息">
              <span class="mr10">{{ mpInfo.principalName }}</span>
            </el-form-item>
            <!-- <el-form-item label="公众号类型">
            <span class="mr10">{{ mpInfo.serviceTypeInfo }}</span>
          </el-form-item> -->
            <el-form-item label="开放平台授权ID">
              <div>
                <span class="mr10">{{ mpInfo.authorizerAppid }}</span>
                <!-- <el-button type="text" @click="unbind">解除绑定</el-button> -->
              </div>
              <div class="form-item-tip">
                公众号和小程序在同一个开放平台帐号下可通过微信授权实现买家唯一身份识别
              </div>
            </el-form-item>
            <el-form-item label="授权状态">
              <div>
                <span class="mr10">已授权</span>
              </div>
              <div class="form-item-tip">
                你的店铺已获得该公众号的所有接口权限，可以正常对接微信如果使用中发现接口有异常
              </div>
            </el-form-item>
          </el-form>
        </div>

        <!--修改开始-->
        <el-table
            stripe
            class="mt20 mb20"
            style="width: 100%"
            :data="AuthList"
            id="table"
            size="small"
            border            
        >
          <el-table-column
              header-align="center"
              align="center"
              prop="principalName"
              label="主体信息"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="type"
              label="授权类型"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.type === 0">微信公众号</span>
              <span v-if="scope.row.type === 2">微信小程序</span>
              <span v-if="scope.row.type === 6">支付宝小程序</span>
            </template>
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="nickName"
              label="授权昵称"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              label="授权状态"
          >
            <template>
              <span class="success">已授权</span>
            </template>
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="createTime"
              label="授权时间"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="authorizerAppid"
              label="APPID"
              v-if="authorized"
          ></el-table-column>
           <el-table-column
              header-align="center"
              align="center"
              label="关联门店"
          >
            <template slot-scope="scope">
              <el-button
                  type="text"
                  class="blue"
                  size="small"
                  @click="edit(scope.row)"
                  v-if="scope.row.type !== 0"
                  >编辑</el-button
                >              
            </template>
          </el-table-column>
        </el-table>

        <el-dialog
            title="关联门店"
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
        >
          <div class="text-center flex item-center">
            <el-form
            label-width="200px"
            >
            <el-form-item label="关联门店">
            <el-select
              clearable
              v-model="shopIdList"
              placeholder="请选择关联门店"
              size="small"
              filterable
              @change="getCheckedStore"
              multiple
            >
              <el-option
                label="全部门店"
                :disabled="selectOther"
                value="all"
              ></el-option>
              <el-option
                :label="v.shopName"
                :disabled="selectAll"
                :value="v.shopId"
                v-for="(v, i) in microShopStoreList"
                :key="i"
              ></el-option>
            </el-select>
            </el-form-item>
            <el-form-item>
              <div class="flex flex-center">
                <el-button type="primary" size="small" @click="save()"
                >保存</el-button
                >
                <el-button size="small" @click="cancel()"
                >取消</el-button
                >
              </div>
            </el-form-item>
            </el-form>
          </div>
        </el-dialog>
        <!--修改结束-->


        <div>
          <hr />
          <div style="margin-left:120px">
            <div class="form-item-tip">
              该功能仅限于使用小程序自定义交易组件接入，使用前请<el-link style="color: #409eff;" href="https://www.yuque.com/docs/share/6b23ec86-111f-451d-baaa-8532690987b2?#" target="_blank" :underline="false" type="primary">检查</el-link>您的小程序是否已经申请开通相关应用
            </div>
            <div>
              <el-button :disabled="show" type="text" size="small" @click="start" >开启使用</el-button>
            </div>
            <div>
              <el-button :disabled="!show" type="text" size="small" @click="initialize">初始化</el-button>
            </div>
          </div>
 
        </div>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { getLoginUser } from "@/utils/auth";
export default {
  data() {
    return {
      show: true,
      authorizedMp: false,
      authorized: false,
      openPlatformParams: {
        componentAccessToken: "",
        componentAccessTokenReceiveTime: "",
        componentAppid: "",
        componentAppsecret: "",
        componentVerifyTicket: "",
        preAuthCode: ""
      },
      mpInfo: {},
      oaInfo: {},
      wechatInfo: {
        principal_name: "",
        // account: "",
        nick_name: "",
        accountType: "",
        appid: "",
        status: "已经授权"
      },
      AuthList:[],
      dialogVisible:false,
      shopIdList:[],
      ShopStoreList:[],
      selectOther: false,
      selectAll: false,
      AppidTemp:"",
    };
  },
  computed: mapGetters([
    "microShopStoreList"
  ]),
  watch: {},
  async created() {
    if (this.$route.query.auth_code) {
      this.postAuthCode();
    }
    this.queryShowType();
    // if (this.$route.query.auth_type === '2') {
    //   this.mpDomainSetting(this.$route.query.componentAppid)
    // }
    this.queryWechatReqParams();
    this.queryOaAuthInfo();
  },
  mounted() {},
  methods: {
    getCheckedStore(storeList) {
      this.selectOther = storeList.findIndex(o => o !== "all") > -1;
      this.selectAll = storeList.findIndex(o => o === "all") > -1;
    },
    edit(row) {
      this.$store.dispatch("queryMicroStoreList");
      this.dialogVisible = true,
      this.AppidTemp = row.authorizerAppid;
      console.log("row.authorizerAppid:",row.authorizerAppid); 
      this.queryShop();
    },
    cancel(){
      this.dialogVisible = false;
      this.AppidTemp = "";
    },
    save(){
        this.updateShop();
    },
    // async createShop(){
    //   const params={
    //     appid : this.AppidTemp,
    //     shopIdList: this.shopIdList        
    //   }
    //   console.log("params:",params);
    //   const { code, result } = await this.$store.dispatch("createShop", params);
    //   if (code === "0") {
    //     this.$message({
    //         message: " 操作成功",
    //         type: "success"
    //     });
    //     this.dialogVisible = false;
    //   }
    // },
    async queryShop(){
      const params={
        appid : this.AppidTemp
      }
      const { result } = await this.$store.dispatch("queryShop", params);
      if (result.length) {
        this.shopIdList = result;
        console.log("result1:",result)
      } else{
        console.log("result2:",result)
        this.shopIdList = ["all"];
      }
      console.log("this.shopIdList:",this.shopIdList)
    },
    async updateShop(){
      const params={
        appid : this.AppidTemp,
        shopIdList: this.shopIdList
      }
      const { code, result } = await this.$store.dispatch("updateShop", params);
      if (code === "0") {
        this.$message({
            message: " 操作成功",
            type: "success"
        });
        this.dialogVisible = false;
      }
    },
    async queryShowType() {
      const { code, result } = await this.$store.dispatch(
        "checkUseAccessWeChatShopFirst"
      );
      if (code === "0") {
        this.show = result;
      }
    },
    async start() {
      if (!this.show) {
        const { code } = await this.$store.dispatch("useAccessWeChatShop");
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryShowType();
        }
      }
    },
    async initialize() {
      if (this.show) {
        const { code } = await this.$store.dispatch(
          "useAccessWeChatShopSecend"
        );
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryShowType();
        }
      }
    },
    async postAuthCode() {
      const { storeCode } = getLoginUser();
      const params = {
        auth_code: this.$route.query.auth_code,
        expires_in: this.$route.query.expires_in,
        auth_type: this.$route.query.auth_type || "",
        store_code: storeCode
      };
      const { code } = await this.$store.dispatch("postAuthCode", params);
      if (code === 0 || code === 200) {
        this.$message({
          message: " 操作成功",
          type: "success"
        });
        this.queryOaAuthInfo();
      }
    },
    // 绑定服务器域名
    async mpDomainSetting(authorizerAppid) {
      let params = {
        authorizerAppid: authorizerAppid,
        action: "set",
        requestdomain: [
          "https://hx.hemiao100.com",
          "https://hexin.hemiao100.com",
          "https://imgcdn.hemiao100.com"
        ],
        wsrequestdomain: ["wss://hx.hemiao100.com"],
        uploaddomain: [
          "https://hx.hemiao100.com",
          "https://imgcdn.hemiao100.com"
        ],
        downloaddomain: [
          "https://hx.hemiao100.com",
          "https://img11.360buyimg.com",
          "https://img13.360buyimg.com",
          "https://img14.360buyimg.com",
          "https://imgcdn.hemiao100.com",
          "https://img30.360buyimg.com",
          "https://wx.qlogo.cn",
          "https://thirdwx.qlogo.cn",
          "https://mmbiz.qpic.cn",
          "https://hexin.hemiao100.com"
        ]
      };
      await this.$store.dispatch("mpDomainSetting", params);
    },
    async queryWechatReqParams() {
      const { result } = await this.$store.dispatch("queryWechatReqParams");
      this.openPlatformParams = result;
    },
    async queryOaAuthInfo() {
      const { result } = await this.$store.dispatch("queryOaAuthInfo");
      // console.log("result:",result)
      if (result.length) {
        this.AuthList = result;
        result.map(v => {
          if (v.type === 2) {
            this.mpInfo = v;
            this.authorizedMp = true;
          } else if (v.type === 0) {
            this.oaInfo = v;
            this.authorized = true;
          }     
        });
      }
    },
    toAuth(type) {
      const { componentAppid, preAuthCode } = this.openPlatformParams;
      let url = `https://mp.weixin.qq.com/cgi-bin/componentloginpage?component_appid=${componentAppid}&pre_auth_code=${preAuthCode}&redirect_uri=${
        window.location.href
      }&componentAppid=${componentAppid}`;
      if (type === "mp") {
        url = url + "&auth_type=2";
      }
      window.location.href = url;
    },
    unbind() {},
    viewPermissions() {},
    authMp() {}
  },  
};
</script>
<style lang="scss" scoped>
.auth-container {
  font-size: 14px;
}
</style>
